import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { Provider } from "react-redux";
import { I18nextProvider } from "react-i18next";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import store from "./app/store";
import Register from "./Pages/Register";
import Login from "./Pages/Login";
import Dashboard from "./Pages/dashboard/dashboard";
import MyOrder from "./Pages/dashboard/MyOrders";
import OrderRequest from "./Pages/dashboard/OrderRequest";
import ApproveOrder from "./Pages/SuperAdmin/ApproveOrder";
import QRFormPage from "./Pages/Consumer/QRFormPage";
import Createuser from "./Pages/SuperAdmin/CreateUser";
import CustomerList from "./Pages/dashboard/CustomerList";
import DealerList from "./Pages/Dealers/UserList";
import CouponStat from "./Pages/dashboard/Couponstat";
import RedeemedCount from "./Pages/dashboard/Redeemedcount";
import RedeemedSummary from "./Pages/dashboard/RedeemedSummary";
import StateReport from "./Pages/Report/stateReport";
import AdminDetails from "./Pages/SuperAdmin/Profile";
import CityReport from "./Pages/Report/CityReport";
import CustomerRedemptionReport from "./Pages/Report/CustomerReport";
import SalesmanReport from "./Pages/Report/SalesmanReport";
import ClientReport from "./Pages/Report/clientReport";
import CreateSalesman from "./Pages/SalesMan/CreateSalesman";
import SalesmanList from "./Pages/SalesMan/SalesmanList";
import AllocateGifts from "./Pages/Gifts/AllocateGifts";
import GiftLList from "./Pages/Gifts/GiftsList";
import CreateSalesmanCustomer from "./Pages/SalesMan/CreateCustomer";
import SalesmanCustomerList from "./Pages/SalesMan/CustomerList";
import SalesmanConsumerQR from "./Pages/Consumer/SalesmanQrScan";
import RedemptionCustomersList from "./Pages/Consumer/RedemptionCustomersList";
import ConsumerLogin from "./Pages/Consumer/Login";
import CreateGifts from "./Pages/Gifts/CreateGift";
import AllocateGiftList from "./Pages/Gifts/AllocateGiftList";
import AddGiftToScheme from "./Pages/Gifts/AddGiftToScheme";
import SalesManDashboard from "./Pages/SalesMan/SalesmanDashboard";
import BannerList from "./Pages/Banners/BannerList";
import CreateBanner from "./Pages/Banners/CreateBanner";
import OffersView from "./Pages/Banners/OffersView";
import QRDesignList from "./Pages/QRDesigns/QRDesignList";
import CreateQRDesign from "./Pages/QRDesigns/CreateQRDesign";
import SalesmanOverview from "./Pages/SalesMan/SalesmanOverview";
import CustomerOffersView from "./Pages/Customer/CustomerOffersView";
import CustomerGiftsSchemes from "./Pages/Customer/CustomerGiftsSchemes";
import AccessModule from "./Pages/Dealers/AccessModule";
import CreateSlogan from "./Pages/Slogan/CreateSlogan";
import SloganList from "./Pages/Slogan/SloganList";
import PromotionalForm from "./Pages/Consumer/PromotionalForm";
import MemberDetailPage from "./Pages/dashboard/MemberDetail";
// import Salesman from "./Pages/Dashboard/Salesman";
import i18n from "./Pages/Components/i18n";

const App = () => {
  return (
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <Router basename="/">
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard/UserList" element={<DealerList />} />
            <Route path="/dashboard/access-module" element={<AccessModule />} />
            <Route path="/dashboard/createuser" element={<Createuser />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/dashboard/orderRequest" element={<OrderRequest />} />
            <Route path="/dashboard/orderApprove" element={<ApproveOrder />} />
            <Route path="/dashboard/couponStat" element={<CouponStat />} />
            <Route
              path="/dashboard/redeemedstatistcis"
              element={<RedeemedCount />}
            />
            <Route path="/dashboard/redeemedstatistcis/summary/:cardType" element={<RedeemedSummary />} />
            <Route path="/dashboard/orders" element={<MyOrder />} />
            <Route path="/consumer/form/:qr_id/" element={<QRFormPage />} />
            <Route
              path="/dashboard/redeemedstatistcis/:salesmanId"
              element={<MemberDetailPage />}
            />
            <Route
              path="/dashboard/redeemedstatistcis/summary/:cardType"
              element={<MemberDetailPage />}
            />
            <Route path="/consumer/form" element={<QRFormPage />} />
            <Route
              path="/consumer/promotionalform/:qr_id/"
              element={<PromotionalForm />}
            />
            <Route
              path="/consumer/promotionalform/"
              element={<PromotionalForm />}
            />
            <Route path="/dashboard/customerList" element={<CustomerList />} />
            <Route path="/dashboard/stateReport" element={<StateReport />} />
            <Route path="/dashboard/cityReport" element={<CityReport />} />
            <Route path="/dashboard/clientReport" element={<ClientReport />} />
            <Route path="/dashboard/salesmanlist" element={<SalesmanList />} />
            <Route path="/dashboard/createslogan" element={<CreateSlogan />} />
            <Route path="/dashboard/sloganlist" element={<SloganList />} />

            <Route
              path="/dashboard/createsalesman"
              element={<CreateSalesman />}
            />

            <Route
              path="/dashboard/allocateGifts"
              element={<AllocateGifts />}
            />
            <Route path="/dashboard/giftList" element={<GiftLList />} />
            <Route
              path="/dashboard/customerReport"
              element={<CustomerRedemptionReport />}
            />
            <Route
              path="/dashboard/salesmanReport"
              element={<SalesmanReport />}
            />
            <Route path="/dashboard/profile" element={<AdminDetails />} />
            <Route
              path="/dashboard/createsalesmancustomer"
              element={<CreateSalesmanCustomer />}
            />
            <Route
              path="/dashboard/salesmancustomerlist"
              element={<SalesmanCustomerList />}
            />
            <Route
              path="/dashboard/salesmanconsumerqr"
              element={<SalesmanConsumerQR />}
            />
            <Route
              path="/dashboard/redemption-customers"
              element={<RedemptionCustomersList />}
            />
            <Route path="/consumer/login" element={<ConsumerLogin />} />
            <Route path="/dashboard/creategift" element={<CreateGifts />} />
            <Route
              path="/dashboard/add-gift-to-scheme"
              element={<AddGiftToScheme />}
            />
            <Route
              path="/dashboard/AllocateGiftList"
              element={<AllocateGiftList />}
            />
            <Route
              path="/dashboard/salesmandashboard"
              element={<SalesManDashboard />}
            />
            <Route path="/dashboard/bannerlist" element={<BannerList />} />
            <Route path="/dashboard/createbanner" element={<CreateBanner />} />
            <Route path="/dashboard/offers" element={<OffersView />} />
            <Route path="/dashboard/qrdesignlist" element={<QRDesignList />} />
            <Route
              path="/dashboard/createqrdesign"
              element={<CreateQRDesign />}
            />
            <Route
              path="/dashboard/salesman-overview"
              element={<SalesmanOverview />}
            />
            <Route
              path="/dashboard/customer-offers"
              element={<CustomerOffersView />}
            />
            <Route
              path="/dashboard/customer-gifts-schemes"
              element={<CustomerGiftsSchemes />}
            />
            {/* Redirect old basename path to root */}
            <Route
              path="/cashback-apmc-loyality"
              element={<Navigate to="/" replace />}
            />
            <Route
              path="/cashback-apmc-loyality/*"
              element={<Navigate to="/" replace />}
            />
            {/* Catch-all route for unmatched paths */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <ToastContainer position="top-right" autoClose={3000} />
        </Router>
      </I18nextProvider>
    </Provider>
  );
};

export default App;
